<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>

      <!--img id="header-s" src="https://i.ibb.co/1J2YTy2/Loyalty-hub-header-s.png" /-->

      <div class="title-page-l header-banner">
        <img
          class="icon-title"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
        />
        <p>คะเเนนสะสม</p>
        <h1>{{ info.point | numFormat("0,000,000") }}</h1>
      </div>
      <div class="container">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          is-full-page="true"
        ></loading>
        <div
          class="alert alert-success"
          role="alert"
          v-if="success"
          style="text-align: center"
        >
          บันทึกข้อมูลสำเร็จ
        </div>
        <div v-if="success">
          <a
            type="submit"
            @click="lastOrder"
            class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
            >ดูรายละเอียดคำสั่งซื้อ</a
          >
        </div>
        <div
          class="alert alert-danger"
          role="alert"
          v-if="failed"
          style="text-align: center"
        >
          บันทึกข้อมูลไม่สำเร็จ
        </div>
        <div
          v-for="(product, index) in products"
          :key="product.productID"
          class="product"
        >
          <div class="card" style="width: 100%; margin-bottom: 20px">
            <a @click="goto('Product02', product.productID)">
              <img
                class="card-img-top"
                :src="'https://api.loyaltyhub.me/public/' + product.image"
                v-if="product.image != ''"
                :alt="product.name"
              />
            </a>
            <div class="cart-fix">
              <span
                data-v-9f7550c6=""
                class="material-icons red"
                style="
                  margin-left: 168px;
                  position: absolute;
                  margin-top: -62px;
                  font-size: 30px;
                  z-index: 50;
                "
                @click="
                  showModal('deleteConfirm');
                  setDelete(product.name, index);
                "
              >
                delete
              </span>
            </div>
            <div class="cart-fix">
              <h5 class="card-title">{{ product.name }}</h5>
              <div class="card-text">
                <span class="name-price"
                  >{{ product.price | numFormat("0,000,000.00") }} บาท</span
                >
              </div>
              <form>
                <div class="form-group" style="text-align: right">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" @click="divide(index)">-</span>
                    </div>
                    <span class="form-control">{{
                      product.quantity | numFormat("0,000,000")
                    }}</span>
                    <!-- <input
                      type="number"
                      class="form-control"
                      :aria-label="product.quantity"
                      value="10"
                      :placeholder="product.quantity"
                    /> -->
                    <div class="input-group-append">
                      <span class="input-group-text" @click="add(index)">+</span>
                    </div>
                  </div>
                </div>
              </form>
              <div class="card-text" style="margin-top: -16px">
                <span class="name-product"
                  >รวม {{ product.amount | numFormat("0,000,000.00") }} บาท</span
                >
              </div>
              <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
            </div>
          </div>
        </div>

        <!-- <div>
            <p>{{ product.description }}</p>
          </div> -->
        <div class="" style="width: 98%">
          <div class="card-body">
            <div class="card-text" style="text-align: left" v-if="!success">
              <span style="text-align: left !important"
                >ยอดรวม {{ amount | numFormat("0,000,000.00") }} บาท</span
              >
            </div>
            <div class="card-text" style="margin-top: 25px" v-if="products.length > 0">
              <div class="bt">
                <a
                  type="submit"
                  class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
                  @click="showModal('orderConfirm')"
                  :disabled="confirmed"
                  >ยืนยัน</a
                >
              </div>
              <div class="bt">
                <a
                  type="submit"
                  class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
                  @click="showModal('cancelOrder')"
                  >ยกเลิก</a
                >
              </div>
              <div class="bt">
                <a
                  @click="goto('Product')"
                  type="submit"
                  class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
                >
                  กลับไปซื้อสินค้าต่อ
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="lastrow"></div>
      <modal name="deleteConfirm" width="80%">
        <div class="">
          <h5 class="card-title">ต้องการลบ {{ deleteName }}</h5>
          <div class="text-center" style="margin-top: 16px">
            <div class="bt">
              <a
                type="submit"
                class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
                @click="confirmRemove"
                >ยืนยัน</a
              >
            </div>
            <div class="bt">
              <a
                type="submit"
                class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
                @click="cancel('deleteConfirm')"
                >ยกเลิก</a
              >
            </div>
          </div>
        </div>
      </modal>
      <modal name="cancelOrder" width="80%">
        <div class="" style="height: 100%">
          <h5 class="card-title">ยกเลิกรายการทั้งหมด</h5>
          <div class="text-center" style="margin-top: 16px">
            <div class="bt">
              <a
                type="submit"
                class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
                @click="cancelOrder"
                >ยืนยัน</a
              >
            </div>
            <div class="bt">
              <a
                type="submit"
                class="btn btn-reset btn-lg btn-block mt-30"
                @click="cancel('cancelOrder')"
                >ยกเลิก</a
              >
            </div>
          </div>
        </div>
      </modal>
      <modal
        name="orderConfirm"
        width="98%"
        scrollable="true"
        height="auto"
        max-height="80%"
      >
        <div class="card" style="width: 98%; padding: 0.2em">
          <h5 class="card-title">ยืนยันคำสั่งซื้อ</h5>

          <p></p>
          <pre
            v-html="content.detail"
            style="padding-top: 1em; margin-left: 0"
            class="detail"
          ></pre>

          <p style="margin-right: -100px">
            ยอดรวม {{ amount | numFormat("0,000,000.00") }} บาท
          </p>
          <p></p>
          <h5 class="card-title">ข้อมูลการจัดส่ง</h5>
          <div class="card-text">
            <div class="form-group">
              <label for="exampleInputEmail1">ชื่อ - นามสกุล (* required)</label>
              <input
                type="text"
                class="form-control"
                id="shipping_name"
                aria-describedby="shipping_name"
                placeholder="ชื่อ"
                v-model="shipping_name"
              />
            </div>
            <div class="form-group">
              <label for="shipping_phone">เบอร์โทรศัพท์ (* required)</label>

              <input
                type="text"
                class="form-control"
                id="shipping_phone"
                placeholder="08123456789"
                v-model="shipping_phone"
              />
            </div>
            <div class="form-group">
              <label for="shipping_address">ที่อยู่ (* required)</label>
              <textarea
                class="form-control"
                id="shipping_address"
                rows="3"
                v-model="shipping_address"
              ></textarea>
            </div>
            <div class="form-group">
              <label for="shipping_province">จังหวัด (* required)</label>

              <!--input
                type="text"
                class="form-control"
                id="shipping_phone"
                placeholder="08123456789"
                v-model="phone"
              /-->
              <select
                v-model="shipping_province"
                id="shipping_province"
                class="form-control"
              >
                <option disabled value="">เลือกจังหวัด</option>
                <option
                  v-for="item in provincesList"
                  v-bind:value="item"
                  v-bind:key="item"
                >
                  {{ item }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="shipping_postcode">รหัสไปรษณีย์ (* required)</label>
              <select
                v-model="shipping_postcode"
                id="shipping_postcode"
                class="form-control"
              >
                <option disabled value="">รหัสไปรษณีย์</option>
                <option v-for="item in postCode" v-bind:value="item" v-bind:key="item">
                  {{ item }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <attachment v-bind:saleInfo="item" @attachImage="attachImage"> </attachment>
            </div>
          </div>
          <div style="text-align: center" class="bt">
            <a
              v-if="enableConfirm"
              type="submit"
              class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
              @click="confirmOrder"
              >ยืนยัน</a
            >
            <a
              type="submit"
              class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
              style="background-color: #626363; color: white"
              @click="cancel('orderConfirm')"
              >ยกเลิก</a
            >
          </div>
        </div>
        <div class="lastrow"></div>
      </modal>
    </body>
  </html>
</template>
<script>
//import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { DateTimeFunc } from "../libs/constant.js";
import Navbar from "./navbar";
import Attachment from "./Attachment";
// Import component
import Loading from "vue-loading-overlay";
//import VueInstant from "VueInstant";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

//import 'vue-instant/dist/vue-instant.css'
//import VueInstant from 'vue-instant/dist/vue-instant.common'
//console.log(VueInstant)
export default {
  name: "Cart",
  components: {
    loading: Loading,
    navbar: Navbar,
    attachment: Attachment,
    //'vue-instant': VueInstant.VueInstant,
    //"font-awesome-icon": FontAwesomeIcon,
  },
  data() {
    return {
      //selectedEvent:"",
      //suggestionAttribute:"original_title",
      //info: this.$store.state.profile,
      //products: [],
      item: {},
      contentCode: "Payment",
      isLoading: false,
      deleteName: "",
      deleteIndex: null,
      success: false,
      failed: false,
      shipping_name:
        this.$store.state.profile.firstname + " " + this.$store.state.profile.lastname,
      shipping_phone: this.$store.state.profile.phone,
      shipping_address: "",
      //state: "",
      //postcode:"",
      attachImageFile: "",
      shipping_province: "",
      shipping_postcode: "",
    };
  },
  beforeCreate() {
    this.$store.dispatch("listProducts", {
      custId: localStorage.getItem("custId"),
    });
  },

  computed: {
    info() {
      return this.$store.state.profile;
    },
    products() {
      return this.$store.state.cart.filter((item) => {
        return item.custId == localStorage.getItem("custId") && item.custId !== undefined;
      });
    },

    amount() {
      return DateTimeFunc.SUM_ARRAY(
        this.$store.state.cart.filter((item) => {
          return (
            item.custId == localStorage.getItem("custId") && item.custId !== undefined
          );
        }),
        "amount"
      );
    },
    content() {
      return (
        this.$store.state.contents.filter((item) => {
          return item.code == this.contentCode;
        })[0] || { detail: "" }
      );
    },
    provincesList() {
      let tmp = [];

      let result = this.$store.state.postcodeProvinceData
        .map((item) => {
          if (tmp.indexOf(item.provinceThai) == -1) {
            tmp.push(item.provinceThai);

            return item.provinceThai;
          }
        })
        .filter((items) => {
          return items !== undefined;
        });
      // console.log(result);
      return result.sort();
    },
    postCode() {
      let tmp = [];
      // let tmpPostCode ="";
      let result = this.$store.state.postcodeProvinceData
        .map((item) => {
          if (
            item.provinceThai == this.shipping_province &&
            tmp.indexOf(item.postcode) == -1
          ) {
            tmp.push(item.postcode);
            return item.postcode;
          } else {
            return item.something;
          }
        })
        .filter((item) => {
          return item !== undefined;
        });
      console.log(result);
      return result.sort();
    },

    enableConfirm() {
      if (
        this.shipping_province != "" &&
        this.shipping_address != "" &&
        this.shipping_postcode != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.$store.dispatch("setContent", {
      custId: localStorage.getItem("custId"),
    });
    //console.log(this.$store.state.postcodeProvinceData);
  },
  methods: {
    lastOrder() {
      this.$router.push({
        name: "LastOrderHistoryDetail",
        params: {},
      });
    },

    attachImage(data) {
      console.log(data);
      this.attachImageFile = data;
    },
    cancelOrder() {
      this.$store.dispatch("cancelOrder");
      this.$modal.hide("cancelOrder");
    },
    setDelete(name, index) {
      this.deleteName = name;
      this.deleteIndex = index;
    },
    showModal(modalName) {
      this.$modal.show(modalName);
    },
    cancel(name) {
      this.$modal.hide(name);
    },
    confirmRemove() {
      this.$store.dispatch("removeCart", this.deleteIndex);
      this.cancel("deleteConfirm");
    },
    add(index) {
      this.$store.state.cart[index].quantity++;
      this.$store.state.cart[index].amount =
        this.$store.state.cart[index].price * this.$store.state.cart[index].quantity;
    },
    divide(index) {
      if (this.$store.state.cart[index].quantity > 1)
        this.$store.state.cart[index].quantity--;
      this.$store.state.cart[index].amount =
        this.$store.state.cart[index].price * this.$store.state.cart[index].quantity;
    },
    async confirmOrder() {
      this.$modal.hide("orderConfirm");
      this.success = false;
      this.failed = false;
      this.isLoading = true;
      console.log(this.$store.state.cart.length);

      await this.$store.dispatch("saveOrder", {
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
        amount: this.amount,
        attachImageFile: this.attachImageFile,
        shipping_address: {
          name: this.shipping_name,
          phone: this.shipping_phone,
          address: this.shipping_address,
          state: this.shipping_province,
          postcode: this.shipping_postcode,
        },
      });
      this.payload = {
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
      };
      this.$store.dispatch("orderList", {
        payload: this.payload,
        memberId: this.$store.state.profile._id,
      });
      console.log("confirmOrder");

      if (this.$store.state.cart.length == 0) {
        this.success = !this.success;
      } else {
        this.failed = !this.failed;
      }
      this.isLoading = false;
      this.enableConfirm = false;
      console.log(this.$store.state.cart.length);
      //this.cancel("");
    },
    remainDate(expireDate) {
      return Math.floor((new Date(expireDate) - new Date()) / (1000 * 60 * 60 * 24));
    },
    goto(page, index) {
      console.log(page);
      this.$router.push({
        name: page,
        params: {
          //apiKey: localStorage.getItem("apiKey"),
          //custId: localStorage.getItem("custId"),
          productIndex: index,
        },
      });
    },
  },
  watch: {
    shipping_province: {
      handler(val) {
        console.log(val);
      },
    },
  },
};
</script>
<style scoped>
@import "./Css/style.css";
p {
  font-size: 16px;
  color: white;
  text-align: left !important;
  margin-top: -12px;
}
.card-title {
  padding-left: 0px;
}
.detail {
  margin-top: 0px;
}
.container {
  margin-top: 100px;
  margin-right: auto;
  margin-left: auto;
  position: revert;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}

/*pre {
  display: block;
  margin-top: 0;
  margin-bottom: 0rem;
  overflow: auto;
  font-size: 15px;
  font-family: "Prompt";
  line-height: 0.4;
}
span.form-control {
  padding: 2.6px;
  top: 1px;
}
.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.155rem 0.74rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0px;
}
.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  width: 52%;
}
.card-img,
.card-img-bottom,
.card-img-top {
  width: 37%;
}
.cart-fix {
  margin-left: 134px;
  margin-top: -78.5px;
  flex: 1 1 auto;
  padding: 1rem 1rem 0px 1rem;
}
.row {
  margin-right: 9px !important;
  margin-left: 18px !important;
  margin-top: 19px;
}

.title-page-l {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: "Prompt";
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
  font-family: "Prompt";
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
}
.title-page-r {
  top: 19px;
  position: absolute;
  overflow: visible;
  background: #ffffff;
  border-radius: 30px;
  width: 149px;
  left: 200px;
  height: 29px;
}
.title-page-r p {
  color: #7bc79a;
  padding-top: 10px;
  top: -14px;
}
.bg-white {
  background: #7bc79a;
  border-radius: 10px;
  width: 100%;
  position: relative;
  overflow: visible;
  top: 90px;
}
.bg-white.s {
  background: #7bc79a;
  border-radius: 10px;
  width: 100%;
  position: relative;
  overflow: visible;
  top: 100px;
}

h1 {
  font-size: 20px;
  margin-top: 12px;
  margin-left: 12px;
  padding-left: 41px;
}
p {
  font-size: 16px;
  color: #7f8285;
  text-align: center;
  margin-left: 12px;
  margin-top: -7px;
}
.img-product {
  display: block;
  margin-left: 9;
  margin-right: 9;
  margin-top: 9px;
  padding-right: 12px;
  width: 119px;
  height: 130px;
  float: left;
}
.name-product {
  font-family: "Prompt";
  color: #000;
  margin-top: 13px;
  font-size: 15px;
  text-align: left;
}
.name-price {
  font-family: "Prompt";
  color: #7bc79a;
  padding: 0 0 0 15px;
  margin-top: 3px;
  font-size: 18px;
  padding-left: 0px;
}
.name-time {
  font-family: "Prompt";
  color: #7f8285;
  margin-top: 32px;
  margin-bottom: 0px;
  font-size: 17px;
}
.iconpointproduct {
  display: block;

  margin-right: 2px;
  margin-top: 8px;

  height: 33px;
  float: left;
}
.icon-title {
  display: block;
  margin-left: 3px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  float: left;
}
.progress {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress.s {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress-bar {
  background-color: #7bc79a;
  border-radius: 53px;
}
.progress-bar.s {
  background-color: #7bc79a;
  border-radius: 53px;
}
.row[data-v-1577524d] {
  margin-right: 0px !important;
  margin-left: 0px !important;
}
.lastrow {
  margin-bottom: 200px;
}
.red {
  color: #7bc79a;
}
.vm--modal {
  left: 31px !important;
  width: 310px !important;
  padding: 15px !important;
}
.card {
  border: 0px solid rgba(0, 0, 0, 0.125);
}
.btn {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.btn-accept light-color font-color {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
*/ ;
</style>
